import React from "react";
import { AuthModal as Modal } from "@housebets/housebets-x-package";

import { useGTMEvents } from "app/hooks/useGTMEvents";

import { Wrapper } from "../../auth";
import { IAuthModal } from "./types";

export const AuthModal: React.FC<IAuthModal> = ({
    isOpen,
    onClose
}) => {
    const { modal } = useGTMEvents();

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            blockPageScroll
            afterOpenModal={() => {
                modal.show('auth')
            }}
            onAfterClose={() => {
                modal.close('auth')
            }}
        >
            <Wrapper />
        </Modal>
    )
}

AuthModal.displayName = "AuthModal";